import {Component, Input, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {
  BestuurderCommissaris,
  BokkzAlgDataService,
  BokkzJrDataService, Jaarrapportage, JaarrapportageEntity,
} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-ondertekening-rechtspersoon',
  templateUrl: './ondertekening-rechtspersoon.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule
],
  styleUrls: ['./ondertekening-rechtspersoon.component.css']
})
export class OndertekeningRechtspersoonComponent implements OnInit {

  @Input() public id!: string;
  public jrEntity = {} as JaarrapportageEntity;
  public bestuurderFg = {} as FormGroup;
  public focusedElementId: string | null = null;
  public isRechtspersoon = false;
  public heeftAandelen = false;
  public index = 0;
  public dialogVisible = false;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public optionsBestuurderType: SelectFormControlItem<string>[] = [
    {value: "BESTUURDER_HUIDIG", label: "Bestuurder (huidig)"},
    {value: "BESTUURDER_VOORMALIG", label: "Bestuurder (voormalig)"},
    {value: "COMMISSARIS_HUIDIG", label: "Commissaris (huidig)"},
    {value: "COMMISSARIS_VOORMALIG", label: "Commissaris (voormalig)"},
  ];

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService,
    private fb: FormBuilder) {
    this.bestuurderFg = this.fb.group({
      bestuurders: this.fb.array<BestuurderCommissaris>([]),
    })
  }

  showDialog(index: number) {
    this.index = index;
    this.dialogVisible = true;
  }

  get bestuurders(): FormArray {
    return this.bestuurderFg.get('bestuurders') as FormArray;
  }

  addRij(): void {
    this.bestuurders.push(this.createFormGroup(), { emitEvent: false });
  }

  verwijderRij(index: number): void {
    this.bestuurders.removeAt(index, { emitEvent: false });
    this.saveForm();
  }

  ngOnInit(): void {
    this.jrDataService.jaarrapportageEntity.subscribe((value) => {
      this.jrEntity = value;
      const item = value.rapportage?.bestuurdersCommissarissen;
      if (item) {
        this.updateForm();
      }
    })
    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
    this.jrDataService.heeftAandelen.subscribe((value) => {
      this.heeftAandelen = value;
    })
  }

  createFormGroup(item?: BestuurderCommissaris): FormGroup {
    return this.fb.group({
      managingOrSupervisoryDirectorOrRepresentativeName: this.fb.group({
        value: item ? item.managingOrSupervisoryDirectorOrRepresentativeName?.value : null as unknown as string,
      }),
      ondertekeningJaarrekening: this.fb.group({
        directorType:  this.fb.group({
          value: item ? item.ondertekeningJaarrekening?.directorType?.value : null as unknown as string,
        }),
        legalEntityNameManagingSupervisoryDirector: this.fb.group({
          value: item ? item.ondertekeningJaarrekening?.legalEntityNameManagingSupervisoryDirector?.value : null as unknown as string,
        }),
        signatureManagingSupervisoryDirectorsLocation: this.fb.group({
          value: item ? item.ondertekeningJaarrekening?.signatureManagingSupervisoryDirectorsLocation?.value : null as unknown as string,
        }),
        signatureManagingSupervisoryDirectorsDate: this.fb.group({
          value: item ? item.ondertekeningJaarrekening?.signatureManagingSupervisoryDirectorsDate?.value : null as unknown as Date,
        }),
        directorSignedStatus: this.fb.group({
          value: true,
        }),
        directorReasonNoSignature: this.fb.group({
          value: item ? item.ondertekeningJaarrekening?.directorReasonNoSignature?.value : null as unknown as string,
        }),
      })
    })
  }

  private updateForm(): void {
    const lijst = this.jrEntity.rapportage?.bestuurdersCommissarissen || [];
    const formArray = this.bestuurderFg.get('bestuurders') as FormArray;
    const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;
    while (formArray.length > lijst.length) {
      formArray.removeAt(formArray.length - 1, {emitEvent: false});
    }

    for (let i = 0; i < lijst.length; i++) {
      if (i < formArray.length) {
        const control = formArray.at(i) as FormGroup;
        control.patchValue(lijst[i], {emitEvent: false});
      } else {
        const formGroup = this.createFormGroup(lijst[i])
        formArray.push(formGroup, {emitEvent: false});
      }
    }
    if (focusedControl && document.contains(focusedControl)) {
      focusedControl.focus();
    }
  }

  public saveForm(): void {
    this.bestuurderFg.updateValueAndValidity({ emitEvent: false });
    setTimeout(()=> {
      this.jrEntity = {
        ...this.jrEntity,
        rapportage: {
          ...this.jrEntity.rapportage,
          bestuurdersCommissarissen: this.bestuurderFg.getRawValue().bestuurders,
        }
      } as Jaarrapportage
      this.jrDataService.updateEntity(this.jrEntity);
    },0)
  }
}
